import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { UserType } from 'generated/graphql'
import { useCurrentUserContext } from './useCurrentUser'

interface UseAuthRouteProps {
  role: 'admin' | 'organization' | 'user'
  redirectPath?: string
  showAlert?: boolean
  skip?: boolean
}

function useAuthRoute(props: UseAuthRouteProps) {
  const {
    role = 'user',
    redirectPath = '/',
    showAlert = true,
    skip = false,
  } = props
  const [pass, setPass] = useState(false)
  const { user, loading, error } = useCurrentUserContext()
  const router = useRouter()

  useEffect(() => {
    if (typeof window === 'undefined' || pass || loading || error || skip)
      return

    if (user?.isSuperuser) {
      setPass(true)
      return
    }

    if (role === 'user' && !user) {
      if (showAlert) {
        alert('로그인 후 이용할 수 있습니다')
      }
      redirect(redirectPath)
      return
    }

    if (role === 'organization' && user?.type !== UserType.MANAGER_UNVERIFIED) {
      if (showAlert) {
        alert('기업회원만 이용할 수 있습니다')
      }
      redirect(redirectPath)
      return
    }

    if (role === 'admin' && !user?.isSuperuser) {
      if (showAlert) {
        alert('접근 권한이 없습니다')
      }
      redirect(redirectPath)
      return
    }
    setPass(true)

    function redirect(path: string) {
      if (path === '/') {
        window.location.href = '/'
        return
      }
      router.replace(path)
    }
  }, [role, redirectPath, pass, loading, error, user, showAlert, skip, router])

  return {
    pass,
  }
}

export default useAuthRoute
